<template>
  <div :style="{ width: '100vw', minHeight: '100vh' }" class="landing-wrapper d-flex justify-content-center">
    <div class="text-center d-flex flex-column align-items-center justify-content-center">
      <h1 class="text-danger mt-0 mb-0">404</h1>
      <h4>Page not found</h4>
    </div>
  </div>
</template>

<script>
export default {}
</script>